export const APARTMENTS = [
  {
    id: 1,
    slug: "apartment-1",
    title: "Apartment Sonja with Double Bed A",
    description:
      "Modern apartment with a fully equipped kitchen and premium amenities, ideal for couples or business travelers seeking comfort and style.",
    images: [
      "/assets/images/Apartman1/krevet.jpg",
      "/assets/images/Apartman1/kuhinja.jpg",
      "/assets/images/Apartman1/livingr.jpg",
      "/assets/images/Apartman1/livingr2.jpg",
      "/assets/images/Apartman1/wc.jpg",
      "/assets/images/Apartman1/apartmanvan.jpg",
    ],
    status: "Available",
    capacity: 4,
    bedrooms: 1,
    bathrooms: 1,
    size: 35,
    location: "Rapska 10, 51500 Krk, Croatia",
    address: "Rapska 10, 51500 Krk, Croatia",
    amenities: [
      {
        icon: "Wifi",
        label: "Free WiFi",
        description: "Fast internet",
      },
      {
        icon: "Car",
        label: "Free Parking",
        description: "Secure parking space included",
      },
      {
        icon: "Tv",
        label: "Smart TV",
        description: "Streaming and cable channels",
      },
      {
        icon: "Coffee",
        label: "Full Kitchen",
        description: "Equipped with modern appliances",
      },
      {
        icon: "Wind",
        label: "Air Conditioning",
        description: "Climate control",
      },
      {
        icon: "Coffee",
        label: "Coffee Machine",
        description: "Freshly brewed coffee",
      },
      {
        icon: "TreePine",
        label: "Terrace",
        description: "Private place to sit",
      },
      {
        icon: "Utensils",
        label: "BBQ",
        description: "Outdoor grilling area",
      },
    ],
    keyFeatures: [
      "5-minute walk to city center",
      "Walking distance to beach",
      "Quiet and private",
      "Modern interior",
    ],
    availability: { checkin: "13:00 - 21:00", checkout: "10:00", minStay: 1 },
    host: {
      name: "Guest House Sonja",
      phone: "+385959048811",
      email: "sonja.drglin@gmail.com",
    },
  },
  {
    id: "apartment-2",
    slug: "apartment-2",
    title: "Apartment Sonja with Double Bed B",
    description:
      "Modern apartment with a fully equipped kitchen and premium amenities, ideal for couples or business travelers seeking comfort and style.",
    images: [
      "/assets/images/Apartman2/krevet.jpg",
      "/assets/images/Apartman2/krevet2.jpg",
      "/assets/images/Apartman2/dnevni.jpg",
      "/assets/images/Apartman2/dnevni1.jpg",
      "/assets/images/Apartman2/dnevni3.jpg",
      "/assets/images/Apartman2/kuhinja.jpg",
      "/assets/images/Apartman2/wc.jpg",
      "/assets/images/Apartman2/wc2.jpg",
      "/assets/images/Apartman2/vani.jpg",
      "/assets/images/Apartman2/ulaz.jpg",
    ],
    status: "Available",
    capacity: 4,
    bedrooms: 1,
    bathrooms: 1,
    size: 35,
    location: "Rapska 10, 51500 Krk, Croatia",
    address: "Rapska 10, 51500 Krk, Croatia",
    amenities: [
      {
        icon: "Wifi",
        label: "Free WiFi",
        description: "Fast internet",
      },
      {
        icon: "Car",
        label: "Free Parking",
        description: "Secure parking space included",
      },
      {
        icon: "Tv",
        label: "Smart TV",
        description: "Streaming and cable channels",
      },

      {
        icon: "Coffee",
        label: "Full Kitchen",
        description: "Equipped with modern appliances",
      },
      {
        icon: "Wind",
        label: "Air Conditioning",
        description: "Climate control",
      },
      {
        icon: "Coffee",
        label: "Coffee Machine",
        description: "Freshly brewed coffee",
      },
      {
        icon: "TreePine",
        label: "Terrace",
        description: "Private place to sit",
      },
      {
        icon: "Utensils",
        label: "BBQ",
        description: "Outdoor grilling area",
      },
    ],
    keyFeatures: [
      "5-minute walk to city center",
      "Walking distance to beach",
      "Quiet and private",
      "Modern interior",
    ],
    availability: { checkin: "13:00 - 21:00", checkout: "10:00", minStay: 1 },
    host: {
      name: "Guest House Sonja",
      phone: "+385959048811",
      email: "sonja.drglin@gmail.com",
    },
  },
];

export const ROOMS = [
  {
    id: "room1",
    slug: "room-1",
    title: "Room Sonja with Double Bed A",
    description:
      "A cozy double room with modern amenities and a relaxing garden view. Perfect for couples or solo travelers.",
    images: [
      "/assets/images/Soba1/krevet.jpg",
      "/assets/images/Soba1/vrata.jpg",
      "/assets/images/Soba1/vrata2.jpg",
      "/assets/images/Soba1/hodnik.jpg",
      "/assets/images/Soba1/wc.jpg",
    ],
    status: "Available",
    capacity: 2,
    bedrooms: 1,
    bathrooms: 1,
    size: 15,
    location: "Rapska 10, 51500 Krk, Croatia",
    address: "Rapska 10, 51500 Krk, Croatia",
    amenities: [
      { icon: "Wifi", label: "Free WiFi", description: "Fast internet" },
      {
        icon: "Car",
        label: "Free Parking",
        description: "Secure parking space included",
      },
      {
        icon: "Wind",
        label: "Air Conditioning",
        description: "Climate control",
      },
      { icon: "Tv", label: "Flat-screen TV", description: "Cable channels" },
      {
        icon: "Snowflake",
        label: "Mini Fridge",
        description: "Chilled drinks",
      },
      {
        icon: "Coffee",
        label: "Coffee Machine",
        description: "Freshly brewed coffee",
      },
      {
        icon: "TreePine",
        label: "Terrace",
        description: "Private place to sit",
      },
      {
        icon: "Utensils",
        label: "BBQ",
        description: "Outdoor grilling area",
      },
    ],
    keyFeatures: [
      "5-minute walk to city center",
      "Walking distance to beach",
      "Quiet and private",
      "Modern interior",
    ],
    availability: { checkin: "13:00 - 21:00", checkout: "10:00", minStay: 1 },
    host: {
      name: "Guest House Sonja",
      phone: "+385959048811",
      email: "sonja.drglin@gmail.com",
    },
  },
  {
    id: "room2",
    slug: "room-2",
    title: "Room Sonja with Double Bed B",
    description:
      "Cozy and modern double room with a balcony, free WiFi, and air conditioning. Perfect for couples looking for comfort and style.",
    images: [
      "/assets/images/Soba2/krevet.jpg",
      "/assets/images/Soba2/vrata.jpg",
      "/assets/images/Soba2/hodnik.jpg",
      "/assets/images/Soba2/ogledalo.jpg",
      "/assets/images/Soba2/wc.jpg",
    ],
    status: "Available",
    capacity: 2,
    bedrooms: 1,
    bathrooms: 1,
    size: 15,
    location: "Rapska 10, 51500 Krk, Croatia",
    address: "Rapska 10, 51500 Krk, Croatia",
    amenities: [
      { icon: "Wifi", label: "Free WiFi", description: "Fast internet" },
      {
        icon: "Car",
        label: "Free Parking",
        description: "Secure parking space included",
      },
      {
        icon: "Wind",
        label: "Air Conditioning",
        description: "Climate control",
      },
      { icon: "Tv", label: "Flat-screen TV", description: "Cable channels" },
      {
        icon: "Snowflake",
        label: "Mini Fridge",
        description: "Chilled drinks",
      },
      {
        icon: "Coffee",
        label: "Coffee Machine",
        description: "Freshly brewed coffee",
      },
      {
        icon: "TreePine",
        label: "Terrace",
        description: "Private place to sit",
      },
      {
        icon: "Utensils",
        label: "BBQ",
        description: "Outdoor grilling area",
      },
    ],
    keyFeatures: [
      "5-minute walk to city center",
      "Walking distance to beach",
      "Quiet and private",
      "Modern interior",
    ],
    availability: { checkin: "13:00 - 21:00", checkout: "10:00", minStay: 1 },
    host: {
      name: "Guest House Sonja",
      phone: "+385959048811",
      email: "sonja.drglin@gmail.com",
    },
  },
];
